import React from "react";
import { Link } from "react-router-dom";
import LegalLayout, { H2, P, UL, Strong } from "@/pages/LegalLayout";

const TermsPage = () => (
  <LegalLayout
    title="Termos de Uso — Documento Express"
    subtitle="Última atualização: 25 de maio de 2026"
  >
    <P>
      Ao acessar o site da Documento Express, o usuário declara estar ciente e
      de acordo com os presentes Termos de Uso.
    </P>

    <H2>1. Objeto</H2>
    <P>
      O presente termo regula o acesso e utilização do site institucional da
      Documento Express, bem como de seus conteúdos, formulários, plataformas e
      serviços digitais.
    </P>

    <H2>2. Utilização do site</H2>
    <P>O usuário compromete-se a:</P>
    <UL>
      <li>utilizar o site de forma lícita e ética;</li>
      <li>não praticar atividades que comprometam a segurança da plataforma;</li>
      <li>não tentar acessar áreas restritas sem autorização;</li>
      <li>
        não utilizar o site para envio de conteúdos maliciosos, fraudulentos ou
        ilegais.
      </li>
    </UL>

    <H2>3. Propriedade intelectual</H2>
    <P>Todo o conteúdo do site, incluindo:</P>
    <UL>
      <li>marcas;</li>
      <li>logotipos;</li>
      <li>layouts;</li>
      <li>imagens;</li>
      <li>textos;</li>
      <li>interfaces;</li>
      <li>materiais institucionais;</li>
      <li>códigos e elementos visuais;</li>
    </UL>
    <P>
      são de propriedade da Documento Express ou utilizados mediante
      autorização, sendo proibida reprodução sem autorização prévia.
    </P>

    <H2>4. Disponibilidade do serviço</H2>
    <P>A Documento Express poderá:</P>
    <UL>
      <li>atualizar;</li>
      <li>modificar;</li>
      <li>suspender;</li>
      <li>
        interromper funcionalidades do site a qualquer momento, sem aviso
        prévio.
      </li>
    </UL>
    <P>Não garantimos disponibilidade ininterrupta da plataforma.</P>

    <H2>5. Limitação de responsabilidade</H2>
    <P>A Documento Express não se responsabiliza por:</P>
    <UL>
      <li>falhas causadas por terceiros;</li>
      <li>indisponibilidade de internet;</li>
      <li>ataques cibernéticos;</li>
      <li>danos decorrentes do uso inadequado do site;</li>
      <li>conteúdos inseridos por usuários ou terceiros.</li>
    </UL>

    <H2>6. Privacidade e proteção de dados</H2>
    <P>
      O tratamento de dados pessoais segue nossa Política de Privacidade
      disponível na página:{" "}
      <Link to="/politica-de-privacidade" className="text-[#1dc7e9] hover:underline">
        Política de Privacidade Documento Express
      </Link>
      .
    </P>

    <H2>7. Comunicações</H2>
    <P>
      Ao preencher formulários no site, o usuário concorda que a Documento
      Express poderá realizar contatos relacionados:
    </P>
    <UL>
      <li>ao atendimento solicitado;</li>
      <li>demonstrações comerciais;</li>
      <li>informações institucionais;</li>
      <li>suporte e comunicações operacionais.</li>
    </UL>
    <P>O usuário poderá solicitar descadastramento a qualquer momento.</P>

    <H2>8. Legislação aplicável</H2>
    <P>
      Este Termo será regido pelas leis da República Federativa do Brasil,
      especialmente:
    </P>
    <UL>
      <li>Código Civil;</li>
      <li>Marco Civil da Internet;</li>
      <li>Lei Geral de Proteção de Dados (LGPD).</li>
    </UL>

    <H2>9. Foro</H2>
    <P>
      Fica eleito o foro da comarca de São Paulo/SP para dirimir quaisquer
      controvérsias relacionadas a estes Termos de Uso, com renúncia a qualquer
      outro, por mais privilegiado que seja.
    </P>

    <H2>10. Contato jurídico</H2>
    <P>
      Questões jurídicas, notificações formais ou solicitações relacionadas aos
      presentes Termos de Uso poderão ser encaminhadas para o e-mail oficial:
    </P>
    <P>
      <Strong>
        <a
          href="mailto:legal@documentoexpress.io"
          className="text-[#1dc7e9] hover:underline"
        >
          legal@documentoexpress.io
        </a>
      </Strong>
    </P>
  </LegalLayout>
);

export default TermsPage;
